<template>
  <div>
    <card>
      <div class="card-header-custom">
        <button type="submit" class="btn btn-fill btn-primary"
          @click="$router.push('/product_categories/create')"
        >
          <i class="fa fa-plus"></i> Hinzufügen
        </button>
      </div>
      <table-filter :value="tableFilter" @input="searchProductCategory" />
      <div class="row">
        <div class="col-sm-12">
          <transition name="el-fade-in-linear">
            <table class="table table-striped" v-if="! loading">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Gehört zu</th>
                  <th>Buchhaltungs-Konto</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="productCat in productCategories" :key="productCat.id">
                  <td v-text="productCat.name"></td>
                  <td v-text="productCat.parent_category ? productCat.parent_category.name : ''"></td>
                  <td v-text="productCat.accounting_number"></td>
                  <td class="text-right">
                    <div class="td-actions">
                      <a v-tooltip.top-center="'Bearbeiten'" class="btn btn-warning btn-link btn-xs"
                         @click="editProductCat(productCat)">
                        <i class="fa fa-edit"></i>
                      </a>
                      <a v-tooltip.top-center="'Löschen'" class="btn btn-danger btn-link btn-xs"
                         @click="deleteProductCat(productCat)">
                        <i class="fa fa-close"></i>
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </transition>
        </div>
      </div>
      <l-pagination
        background
        layout="prev, pager, next"
        :per-page="10"
        :page-count="pageCount"
        :value="currentPage"
        @input="changePage"
        @changePerPage="changePerPage"
      />
    </card>
  </div>
</template>

<script>
import hasPagination from 'src/has-pagination'
import debounce from 'lodash/debounce'

export default {
  mixins: [hasPagination],
  data () {
    return {
      productCategories: [],
      loading: true
    }
  },
  methods: {
    searchProductCategory (search) {
      this.tableFilter = search
      if (search.length === 0 || search.length > 2) {
        this.currentPage = 1
        this.bla(search)
      }
    },
    bla: debounce(function (search) {
      this.fetchTableData(search)
    }, 500),
    getData (query) {
      this.loading = true
      this.$http.get(`/product_categories?${query}`).then(({ data }) => {
        this.productCategories = data.data
        this.pageCount = data.last_page
        this.loading = false
      })
    },
    editProductCat (productCategory) {
      this.$router.push(`/product_categories/${productCategory.id}/edit`)
    },
    async deleteProductCat (productCategory) {
      if (confirm(`Warengruppe ${productCategory.name} wirklich löschen?`)) {
        await this.initCsrf()

        this.$http.delete(`/product_categories/${productCategory.id}`).then(({ data }) => {
          this.$notify({
            message: `Warengruppe ${data.name} erfolgreich gelöscht.`,
            type: 'success'
          })
          const index = this.productCategories.findIndex(({ id }) => data.id === id)
          this.productCategories.splice(index, 1)
        })
      }
    }
  },
  created () {
    this.fetchTableData()
  }
}
</script>
